import isEmpty from "lodash-es/isEmpty";
import { FieldViewWrapper } from "@/components/molecules/form/FieldViewWrapper";
import type { FieldViewWrapperProperties } from "@/components/molecules/form/FieldViewWrapper";
import { RichTextEditor } from "@/features/sparxsEditor/components/organisms/richTextEditor/RichTextEditor";
import type { RichTextEditorProps } from "@/features/sparxsEditor/components/organisms/richTextEditor/RichTextEditor";

export interface RichTextFieldViewProps
  extends Omit<FieldViewWrapperProperties, "children">, RichTextEditorProps {}

export const RichTextFieldView = ({
  id,
  label,
  initialValue: value,
  onChange,
  onBlur,
  errorMessage,
  toHide = false,
  labelClassName,
  className,
  editorRef,
  ariaInvalid,
  ariaDescribedBy,
  variables,
  disabled = false,
  contentAreaVariant = "default",
  buttons,
  featureBlacklist,
}: RichTextFieldViewProps) => {
  const hasError = !isEmpty(errorMessage);

  return (
    <FieldViewWrapper
      id={id}
      label={label}
      errorMessage={errorMessage}
      toHide={toHide}
      className={className}
      labelClassName={labelClassName}
    >
      <RichTextEditor
        key={id}
        id={id}
        initialValue={value}
        onChange={onChange}
        onBlur={onBlur}
        contentAreaVariant={contentAreaVariant}
        disabled={disabled}
        editorRef={editorRef}
        variables={variables}
        buttons={buttons}
        featureBlacklist={featureBlacklist}
        ariaInvalid={ariaInvalid ?? hasError}
        ariaDescribedBy={
          ariaDescribedBy ?? (hasError ? `${id}-error` : undefined)
        }
      />
    </FieldViewWrapper>
  );
};
